import { format, formatDistanceToNow, parseISO } from 'date-fns'

/** Dates always render in the TENANT's timezone and format, not the browser's. */
export function formatDate(iso: string | null | undefined, pattern = 'dd MMM yyyy'): string {
  if (!iso) return '—'
  return format(parseISO(iso), pattern)
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  return format(parseISO(iso), 'dd MMM yyyy, HH:mm')
}

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return '—'
  return formatDistanceToNow(parseISO(iso), { addSuffix: true })
}

/** Quantities arrive as decimal strings; trim to something a human reads. */
export function formatQuantity(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return '0'
  const text = String(value)
  return text.includes('.') ? text.replace(/\.?0+$/, '') || '0' : text
}

export function formatNumber(value: number, locale = 'en-IN'): string {
  return new Intl.NumberFormat(locale).format(value)
}

export function formatPercent(value: number, decimals = 1): string {
  return `${value >= 0 ? '+' : ''}${value.toFixed(decimals)}%`
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')
}
